import { ChatQueue } from '../types/async-config';
import { ChatSessionState } from '../types/call-guide/state';
import { boostSession, chatSession } from '../utils/session';
import { RootState } from './store';

type Selector<R = boolean> = (state: RootState) => R;

const createChatStateSelector =
  (...states: ChatSessionState[]): Selector =>
  ({ chatState }) =>
    !!chatState.currentState && states.includes(chatState.currentState);

export const chatSessionIsActive = createChatStateSelector(
  'queue',
  'startup',
  'placedInQueue',
  'established'
);

export const chatSessionIsOver = createChatStateSelector(
  'finished',
  'afterChat'
);

export const hasMultipleTilganger: Selector = ({ bruker }) =>
  !!bruker.tilganger && bruker.tilganger.length > 1;

export const isChatWindowVisible: Selector = (state) =>
  state.chatWindow.isVisible || chatSession.isWindowVisible();

export const isRobotChat: Selector = ({ chatState }) =>
  !!chatState.stateInfo.established && boostSession.exists();

const isRobot = (queue?: ChatQueue) => !!queue && 'robot' in queue;

export const hasSelectedRobotTopic: Selector = ({
  topicSelection: { customerType, mainTopic, subTopic }
}) => isRobot(customerType) || isRobot(mainTopic) || isRobot(subTopic);

export const shouldShowMessengerView: Selector = (state) =>
  (chatSessionIsActive(state) || chatSessionIsOver(state)) &&
  state.chatState.messages.length > 0;

export const getDataDc: Selector<string | undefined> = (state) => {
  const entries = Object.entries({
    application_module: 'chat',
    customer_segment:
      state.topicSelection.subTopic?.customerSegment ??
      state.topicSelection.mainTopic?.customerSegment,
    business_area: state.topicSelection.customerType?.businessArea
  }).filter(([, value]) => !!value);

  return entries.length
    ? JSON.stringify(Object.fromEntries(entries))
    : undefined;
};
